import React, { Component } from 'react';
import { connect } from 'formik';
import { injectIntl } from 'react-intl';

import mapExperienceToCheckout from '../../shared/mapExperience.js';

import Heading from './experiences-step/heading.section.js';
import ExperienceGrid from '../../components/experiences-grid/experiences.component.js';

import ExperiencesService from '../experiences/experiences.service.js';

import './experiences.step.scss';

class ExperiencesStep extends Component {
	state = {
		experiencesCategories: null,
		filters: null,
		rangePrice: null,
	};

	componentDidMount() {
		const { experiencesCategories, rangePrice } = this.state;

		if (!experiencesCategories) {
			this.fetchExperiencesCategories();
		}

		if (!rangePrice) {
			this.fetchRangePrice();
		}
	}

	selectExperience = (experience) => {
		const { formik, handleNextPage } = this.props;
		const a = mapExperienceToCheckout(experience);
		formik.setValues(a);
		setTimeout(() => {
			handleNextPage();
		}, 400);
	};

	fetchExperiencesCategories= () => {
		const { intl: { locale } } = this.props;
		ExperiencesService.getCategories(locale)
			.then(response => this.setState({ experiencesCategories: response }));
	};

	fetchRangePrice= () => {
		const { intl: { locale } } = this.props;
		ExperiencesService.getRangePrice(locale)
			.then(response => this.setState({ rangePrice: response }));
	};

	handleFilters = values => (
		this.setState({ filters: values })
	);

	render() {
		const { filters, experiencesCategories, rangePrice } = this.state;
		const { formik, intl } = this.props;

		if (!experiencesCategories || !rangePrice) { return null; }

		return (
			<div className="experiences">

				<Heading
					handleSubmit={this.handleFilters}
					categories={experiencesCategories}
					rangePrice={rangePrice}
				/>

				<ExperienceGrid
					filters={filters}
					handleSelect={this.selectExperience}
					selected={formik.values}
					language={intl.locale}
				/>

			</div>
		);
	}
}

export default injectIntl(connect(ExperiencesStep));
